import React from "react"
import {connect} from 'react-redux'

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles"

// @material-ui/icons
import PermIdentity from "@material-ui/icons/PermIdentity"

// core components
import GridContainer from "components/GridContainer"
import GridItem from "components/GridItem"
import Clearfix from "components/Clearfix"
import Card from "components/Card"
import CardBody from "components/CardBody"
import CardHeader from "components/CardHeader"
import CardIcon from "components/CardIcon"
import Table from "components/Table"

// assets
import userProfileStyles from "./userProfileStyles.jsx"

// Services
import {getUser} from '_services/user.service.js'



class Account extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: {
        first_name: "",
        last_name: "",
        email: "",
        locale: "",
        role: "",
        organisation_id: "",
        partner_id: "",
        internal_user: false,
        id: "",
        cognito_details: {
          mfa_enabled: false,
          status: ""
        }
      },
      loading: false
    }
  }

  componentDidMount() {
    const { user_authentication } = this.props;
    const userId = user_authentication.profile.username;
    
    this.setState({ loading: true });
    console.warn('Trying to get user');
    
    getUser(
      userId,
      (data) => {
        this.setState({ 
          user: data,
          loading: false 
        });
      },
      (error) => {
        console.warn("Failed to fetch user data:", error);
        this.setState({ loading: false });
      }
    );
  }

  render() {
    const {classes} = this.props;
    const {user, loading} = this.state;

    return (
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              <Card>
                <CardHeader color="primary" icon>
                  <CardIcon color="primary">
                    <PermIdentity/>
                  </CardIcon>
                  <h4 className={classes.cardIconTitle}>
                    {"Profile"}
                  </h4>
                </CardHeader>
                <CardBody>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      {loading ? (
                        <p>Loading...</p>
                      ) : (
                        <Table
                          tableHeaderColor="primary"
                          style={{fontSize: '10px'}}
                          tableData={[
                            [<b>{"First Name"}</b>, user.first_name],
                            [<b>{"Last Name"}</b>, user.last_name],
                            [<b>{"Locale"}</b>, user.locale],
                            [<b>{"Mail Address"}</b>, user.email],
                            [<b>{"Role"}</b>, user.role],
                            ["", ""]
                          ]}
                        />
                      )}
                    </GridItem>
                  </GridContainer>
                  <Clearfix/>
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
        </GridItem>
      </GridContainer>
    )
  }
}

function mapStateToProps(state) {
  return {
    user_authentication: state.authentication.user,
  }
}


export default withStyles(userProfileStyles)(connect(mapStateToProps)(Account))
